const accordionVariants = {
    viewPicks: {
        panelHeader: {
            cursor: "default",
        }
    }
};
export { accordionVariants };
//# sourceMappingURL=accortion.js.map